import Cookies from "js-cookie"

const token_key = 'appoint-pc-access-token'

export function getToken() {
  const token = Cookies.get(token_key)
  if (token !== undefined) {
    setToken(token)
  }
  return token
}

export function setToken(token) {
  let expireTimes = new Date(new Date().getTime() + 15 * 60 * 1000)
  return Cookies.set(token_key, token, {
    expires: expireTimes
  })

}

export function removeToken() {
  return Cookies.remove(token_key)
}
